import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="landing-page landing-simple">
      <div className="landing-center">
        <div className="logo-large">
          <span className="logo-en">Japanese</span>
          <span className="logo-en">Learning</span>
        </div>
        
        <p className="landing-tagline">
          Online Japanese Lessons for Filipinos
        </p>

        <div className="landing-buttons">
          {isAuthenticated ? (
            <Link 
              to={user?.role === 'admin' ? '/admin' : user?.role === 'teacher' ? '/teacher' : '/student'} 
              className="btn btn-primary btn-lg"
            >
              Go to Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn btn-primary btn-lg">
                Login
              </Link>
              <Link to="/login?register=true" className="btn btn-outline btn-lg">
                Sign Up
              </Link>
            </>
          )}
        </div>

        <div className="landing-footer-simple">
          <p>© 2024 Japanese Learning System</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
